import { EyeOutlined, HolderOutlined } from '@ant-design/icons';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Flex, Space } from 'antd';
import type { CSSProperties, FC } from 'react';
import { Box } from '../Box';
import { Button } from '../Button';
import { Text } from '../Text';
import type { DnDColumnItem } from './types';

type Props = {
  column: DnDColumnItem;
  onHide: (columnKey: string) => void;
};

export const SortableItem: FC<Props> = ({ column, onHide }) => {
  const {
    attributes,
    isDragging,
    listeners,
    setNodeRef,
    transform,
    transition,
  } = useSortable({
    id: column.title,
  });

  const style: CSSProperties = {
    cursor: isDragging ? 'grabbing' : 'grab',
    width: '100%',
    marginRight: 8,
    transition,
    transform: CSS.Transform.toString(transform),
  };

  return (
    <Flex
      wrap="wrap"
      align="center"
      justify="space-between"
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...listeners}
    >
      {column.title ? (
        <>
          <Space>
            <HolderOutlined style={{ cursor: 'grab', fontSize: 24 }} />
            <Text text={column.title} />
          </Space>
          <Button
            type="text"
            onClick={(e) => {
              e.stopPropagation();
              onHide(column.key);
            }}
            icon={<EyeOutlined style={{ fontSize: 16 }} />}
          />
        </>
      ) : (
        <Box minHeight={16} /> // Empty Drop area.
      )}
    </Flex>
  );
};
